import {
  DIM_HEX_BY_VUETIFY_COLOR,
  getVuetifyColorForVehicleTypeId,
} from "@/filters/vehicleTypeColorMap";

export function getDimColorFromVehicleType(
  vehicleTypeId?: number | null
): string {
  const color = getVuetifyColorForVehicleTypeId(vehicleTypeId);
  return DIM_HEX_BY_VUETIFY_COLOR[color];
}
